export * as FULL_SCHEMA from 'vets-json-schema/dist/10-10D-EXTENDED-schema.json';
export { CONTACTS } from '@department-of-veterans-affairs/component-library/contacts';

export { default as commonDefinitions } from 'vets-json-schema/dist/definitions.json';

export {
  VaRadio,
  VaRadioOption,
} from '@department-of-veterans-affairs/component-library/dist/react-bindings';
